import { createContext } from "react"
import type { HelmetServerState } from "@dr.pogodin/react-helmet"

// Provided by entry.server so the root HelmetProvider can hand its SSR state
// back out for injection into <head>. Undefined on the client.
export const HelmetServerStateContext = createContext<
  ((state: HelmetServerState) => void) | undefined
>(undefined)
